<template>
    <ul class="survey_list">
        <li>
            <div class="bx_title">
                <strong class="title"><span class="num">{{questionIndex + 1}}.&nbsp;</span>{{question.question}}</strong>
                <p class="desc" v-show="questionInfoMessage">{{questionInfoMessage}}</p>
            </div>
            <img :src="question.image.url" alt="" v-if="question.image" @click="onClickPreviewImage(question.image.url)">

            <!-- [D] 선착순 리스트의 경우 : first_come -->
            <ul class="answer_list first_come">
                <EnrolmentResponseProgram v-for="(program, index) in question.programs" :key="program.programNumber" :program="program"
                                          :questionNo="question.questionNo" :answer-index="index"></EnrolmentResponseProgram>
            </ul>
        </li>
    </ul>
</template>

<script>
import {SURVEY_ANSWER_STATE_TYPE} from '@common/consts/response.js';
import {IS_AFTER_ENROLMENT_PERIOD} from '@common/store/modules/enrolment/response.js';
import {ENROLMENT_RESPONSE_NAMESPACE} from '@common/store';

import EnrolmentResponseProgram from '@iamschoolpc/components/response/EnrolmentResponseProgram.vue';

import {createNamespacedHelpers} from 'vuex';

const {mapState, mapGetters} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: 'EnrolmentResponseQuestion',
    components: {EnrolmentResponseProgram},
    data() {
        return {};
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
        questionIndex: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ...mapState({
            answerStateType: state => state.survey.answerStateType,
            endDate: state => state.survey.endDate,
            isPreview: state => state.options.isPreview,
        }),

        ...mapGetters({
            isEndEnrolment: IS_AFTER_ENROLMENT_PERIOD,
        }),

        isWebView() {
            return this.$route.query.hasOwnProperty('isMasking');
        },

        questionInfoMessage() {
            if (this.isEndEnrolment) {
                return this.$t('EnrolmentResponseQuestion_cantEditEndedEnrolment');
            }
            if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                return this.$t('EnrolmentResponseQuestion_pleaseSelectApply');
            }
            if (this.question.maxChoice !== 0) {
                return this.$t('EnrolmentResponseQuestion_canApplyMaxProgram', {max: this.question.maxChoice});
            }
            return this.$t('EnrolmentResponseQuestion_canApplyNoLimit');
        },

        questionNumber() {
            return this.questionIndex + 1;
        },
    },

    methods: {
        onClickPreviewImage(url) {
            window.open(url);
        },

    },

};
</script>

<style scoped>

</style>
